import React from "react";
import DataTable from "react-data-table-component";

const customStyles = {
  headRow: {
    style: {
      border: "none",
      backgroundColor: "rgba(248, 249, 249, 1)",
    },
  },
  headCells: {
    style: {
      color: "#202124",
      fontSize: "14px",
    },
  },
  rows: {
    highlightOnHoverStyle: {
      backgroundColor: "rgb(230, 244, 244)",
      borderBottomColor: "#FFFFFF",
      borderRadius: "0px",
      outline: "1px solid #FFFFFF",
    },
  },
  pagination: {
    style: {
      border: "none",
    },
  },
};

const DataTablePagination1 = ({
  columns,
  data = [],
  totalRows,
  page,
  perPage,
  onPageChange,
  onPerPageChange,
}) => {
  return (
    <DataTable
      className="react-data-table-component"
      columns={columns}
      data={data || []}
      pagination
      paginationServer
      paginationTotalRows={totalRows}
      paginationPerPage={perPage}
      paginationRowsPerPageOptions={[5, 10, 20, 30]}
      paginationDefaultPage={page}
      onChangePage={onPageChange}
      onChangeRowsPerPage={onPerPageChange}
      customStyles={customStyles}
      highlightOnHover
      noDataComponent={
        <div style={{ padding: "20px", textAlign: "center" }}>
          No records found
        </div>
      }
    />
  );
};

export default React.memo(DataTablePagination1);
